import styled, { css } from "styled-components";
import { Icon } from "@sproutsocial/seeds-react-icon";
import {
  MenuToggleButton,
  type TypeMenuToggleButtonProps,
} from "./MenuToggleButton";
import { useMenuToggleContext } from "./MenuContext";

export interface TypeListboxToggleButtonProps
  extends TypeMenuToggleButtonProps {
  invalid?: boolean;
  size?: "small" | "default" | "large";
}

export const StyledListboxToggleButton = styled(
  MenuToggleButton
)<TypeListboxToggleButtonProps>`
  background-color: ${(props) => props.theme.colors.form.background.base};
  border: 1px solid ${(props) => props.theme.colors.form.border.base};
  border-radius: ${(props) => props.theme.radii[500]};
  transition: border-color ${(props) => props.theme.duration.fast}
      ${(props) => props.theme.easing.ease_in},
    box-shadow ${(props) => props.theme.duration.fast}
      ${(props) => props.theme.easing.ease_in};
  font-weight: ${(props) => props.theme.fontWeights.normal};
  &:active {
    transform: none;
  }

  padding: ${(props) => {
    switch (props.size) {
      case "large":
        return `${props.theme.space[400]} ${props.theme.space[400]} ${props.theme.space[400]} ${props.theme.space[400]}`;

      case "small":
        return `${props.theme.space[200]} ${props.theme.space[200]} ${props.theme.space[200]} ${props.theme.space[200]}`;

      case "default":
      default:
        return `${props.theme.space[300]} ${props.theme.space[300]} ${props.theme.space[300]} ${props.theme.space[300]}`;
    }
  }};
  font-size: ${(props) => {
    switch (props.size) {
      case "large":
        return props.theme.typography[300].fontSize;

      case "small":
      case "default":
      default:
        return props.theme.typography[200].fontSize;
    }
  }};

  ${(props) =>
    props.invalid &&
    css`
      border-color: ${(props) => props.theme.colors.form.border.error};
    `}
`;

export interface TypeStyledChevronProps {
  $isOpen?: boolean;
  invalid?: boolean;
}

const StyledChevron = styled.div<TypeStyledChevronProps>`
  margin-left: ${({ theme }) => theme.space[300]};
  ${({ $isOpen }) =>
    $isOpen &&
    `
		transform: rotate(-180deg);
	`}
  transition: transform 0.15s;

  ${({ invalid }) =>
    invalid &&
    css`
      color: ${(props) => props.theme.colors.icon.error};
    `}
`;

const StyledInnerButton = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ListboxToggleButton = ({
  children,
  size = "default",
  ...buttonProps
}: TypeListboxToggleButtonProps) => {
  const { isOpen } = useMenuToggleContext();
  return (
    <StyledListboxToggleButton
      appearance="unstyled"
      size={size}
      {...buttonProps}
    >
      <StyledInnerButton>
        {children}
        <StyledChevron $isOpen={isOpen} invalid={buttonProps.invalid}>
          <Icon name="chevron-down-outline" fixedWidth aria-hidden />
        </StyledChevron>
      </StyledInnerButton>
    </StyledListboxToggleButton>
  );
};
